export default "__VITE_PUBLIC_ASSET__c447d7b7__"